import { axiosInstance } from './common';

export const submitOnboarding = (data) =>
  axiosInstance.post('/onboarding', data).then((r) => r.data);

export const checkEmailExists = (email) =>
  axiosInstance.post('/auth/checkEmail', { email }).then((r) => r.data).catch(() => ({ exists: false }));
